export const T = {
  en_GB: { noUrl: "No web page URL configured" },
  nb_NO: { noUrl: "Ingen nettside-URL er satt opp" },
} as const;
